var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrainingLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 275,
    height: 191,
    viewBox: "0 0 275 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M198.569 133.031C195.77 132.232 193.012 131.232 190.293 130.113C178.899 125.396 147.315 113.165 139.199 111.246",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.249 132.991C274.41 155.096 273.89 147.901 273.89 147.901C276.809 140.866 220.558 115.763 207.564 110.127C205.765 109.327 203.766 109.007 201.807 109.167C177.54 110.846 149.154 105.65 149.154 105.65H149.194C151.433 102.971 152.752 99.4938 152.752 95.7363C152.752 87.1421 145.796 80.2267 137.24 80.2267C128.645 78.6278 96.421 65.4367 85.0268 60.7198C82.3081 59.6006 79.5496 58.6412 76.751 57.8018C0.549839 35.7366 1.10955 42.8918 1.10955 42.8918C-1.80896 49.9271 54.4424 75.0302 67.4357 80.6665C69.2348 81.4659 71.2338 81.7857 73.1928 81.6258C97.4604 79.9469 125.846 85.1434 125.846 85.1434C123.247 87.9016 121.648 91.6591 121.648 95.7763C121.648 104.371 128.605 111.286 137.16 111.286C137.72 111.286 138.28 111.246 138.839 111.206",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M218.519 138.628C203.047 167.488 172.542 187.155 137.48 187.155C111.653 187.155 88.3052 176.482 71.5938 159.334C86.0664 171.646 105.097 178.801 125.606 178.801C157.91 178.801 185.935 160.293 199.608 133.311",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M227.754 112.645C228.833 107.009 229.393 101.213 229.393 95.2968C229.393 44.5708 188.254 3.43848 137.52 3.43848C107.975 3.43848 81.7084 17.3891 64.877 39.0146C79.9892 22.9054 101.778 13.072 125.646 13.072C171.423 13.072 208.524 50.1671 208.524 95.9363C208.524 99.0143 208.364 102.052 208.044 105.05L227.754 112.645Z",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9165 85.1834C65.4368 88.4612 65.1969 91.8589 65.1969 95.2566C65.1969 133.151 95.9412 163.891 133.842 163.891C153.592 163.891 171.623 155.736 184.176 142.385C170.263 160.333 148.474 171.885 124.007 171.885C81.9884 171.885 47.8857 137.828 47.8857 95.7763C47.8857 90.5398 48.4055 83.7443 49.8847 78.8276",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8389 53.285C74.5119 33.0186 97.7001 19.7075 123.967 19.7075C145.356 19.7075 164.706 28.5416 178.539 42.772C166.545 32.5789 150.793 26.6628 133.802 26.6628C109.854 26.6628 88.7446 38.9346 76.4709 57.5621",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M49.8447 78.8276L65.9165 85.1834",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M32.293 46.0897C47.1654 23.5449 73.2721 5.71683 97.8595 1C78.7893 6.51629 59.0793 22.9453 47.2853 40.8133C45.6462 43.2916 44.1269 45.8499 42.7676 48.4481",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M238.988 143.984C224.316 166.609 198.329 184.676 173.821 189.593C192.852 183.917 212.402 167.328 224.036 149.38C225.675 146.862 227.154 144.304 228.473 141.705",
    stroke: "white",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrainingLogo);
export default __webpack_public_path__ + "static/media/training-logo.1de907a6225133d12379b314b9199568.svg";
export { ForwardRef as ReactComponent };